<template>
  <div>
    <m-modal-spinner v-if="spinner" :addcancel="true"
      explain="Chargement...<br>Ce logiciel est un outil d’aide et n’est pas destiné au diagnostic ni à a la planification détaillée du traitement des patients"
      @cancel="cancelSend"></m-modal-spinner>
    <!-- <euros-header titre="Ajouter une radio de la hanche" pathRetour="/patients"></euros-header> -->
    <div class="position-relative w-100">
      <div class="container">
        <div class="row pt-4">
          <div class="col">
            <h1>ACTIVITÉS</h1>
            <h2>HANCHE</h2>
          </div>
        </div>
      </div>

      <div class="position-absolute" style="z-index: 2000; top: 10px; right: 10px">
        <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon" @click="finish"
          style="width: 30px; height: 30px; min-height: 0">
          <icon width="20" height="20" name="times"></icon>
        </div>
        <div @click="help" class="mt-3 aide pointer color-white d-flex flex-row align-items-left justify-content-start"
          style="background-color:white; border-radius: 50%;">
          <icon width="30" height="30" name="question-circle" class="" color="#a2acbf"></icon>
        </div>

      </div>
    </div>
    <tab-bar currentActive="newpatient"></tab-bar>
    <div class="container-fluid bg-blue d-flex flex-column">
      <div class="d-none d-md-block flex-grow-0">
        <div class="row pt-2">
          <div class="col-sm-3 d-flex align-items-center justify-content-between justify-content-sm-start mb-2 mb-sm-0">
            <div>
              <img style="width: 120px" class="img-fluid" src="/images/logo-euros-2025.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <div class="row">
          <div class="col-md-6 d-flex align-items-center justify-content-center justify-content-md-end">
            <div class="">
              <div class=" text-center mb-3">Ajouter une radio</div>
              <div @click="changefile" class="container-icon d-flex align-items-center justify-content-center">
                <icon width="90" height="90" color="white" name="file-image" class="mr-2"></icon>
                <input hidden type="file" ref="inputfile" name="inputfile" accept="image/*, application/dicom"
                  @change="inputFileChange($event)" />
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-2 d-flex align-items-center justify-content-center justify-content-md-start">
            <div class="mt-3">
              <div class="bis text-center">Choisissez votre fichier au format :</div>
              <div class="text-center">.DICOM, .JPEG / .JPG, .PNG</div>
              <!-- <div @click="help"
                class="mt-3 aide pointer color-white d-flex flex-row align-items-left justify-content-start">
                <div class="d-none d-sm-block"><a href="javascript:void(0);">Télécharger l'aide</a></div>
                <icon width="22" height="22" name="question-circle" class="ml-2" color="#a2acbf"></icon>
              </div> -->
            </div>
          </div>

          <!--         <div class="col-md-5 offset-md-1 py-5 d-flex align-items-center">
        
           <div class="container-icon d-flex align-items-center justify-content-center">
            <icon width="60" height="60" color="gray" name="camera-retro" class="mr-2"></icon>
          </div>
          <div class="bis text-center mt-3">
            Prendre une photo
          </div>
        </div> -->
        </div>
      </div>
    </div>

    <div class="winmodal" v-if="$store.state.help.chooseimage"></div>
    <div class="helpwin" v-if="$store.state.help.chooseimage">
      <div class="winclose">
        <label for="notdisplayanymore" style="margin: -5px 30px"><input type="checkbox" id="notdisplayanymore"
            v-model="notdisplayanymore" />Ne plus afficher</label>
        <a href="javascript:void(0);" @click="$store.commit('set_help', ['chooseimage', notdisplayanymore])">
          <icon width="24" height="24" name="times" class="" color="black"></icon>
        </a>
      </div>
      <div class="row">
        <div class="col-md-8">
          <h3>Cliquez sur le bouton Choisir un fichier et le récupérer sur votre ordinateur.</h3>
          <p>Le fichier peut être un JPEG JPG, un PNG ou un DICOM</p>
          <div>
            <button class="btn btn-primary" @click="clickHelp">CHOISIR UN FICHIER</button>
          </div>
        </div>
        <div class="col-md-4">
          <img src="/images/aide/02-choisir-fichier.png" class="img-fluid" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "chooseimage",
  components: {},

  data() {
    return {
      notdisplayanymore: false,
      spinner: false,
      cancelTokenSource: null
      // fileSelected: {}
    };
  },
  async mounted() {
    this.cancelTokenSource = null;
    this.$store.dispatch("addHistoryUrl", this.$route.path);
  },
  watch: {},
  computed: {},
  methods: {
    clickHelp() {
      this.$store.commit("set_help", ["chooseimage", this.notdisplayanymore]);
      this.$refs.inputfile.click();
    },
    help() {
      window.open(this.$config.server_url + "/api/1.0/files/help" + "?token=" + this.$store.state.accesstoken + "&origin=webapp", "_blank");
    },
    cancelSend() {
      this.spinner = false;
      if (this.cancelTokenSource) this.cancelTokenSource.cancel();
      // this.$router.push("/patients");
    },
    changefile() {
      this.$refs.inputfile.click();
    },
    async inputFileChange(e) {
      let maxWait = 3000,
        time = new Date();
      if (!e.target.files.length) return;

      this.spinner = true;
      let file = e.target.files[0];
      let formdata = new FormData();
      formdata.append("file", file);

      try {
        this.cancelTokenSource = this.$axios.CancelToken.source();
        let response = await this.$axios.post(this.$config.server_url + "/api/1.0/files", formdata, {
          cancelToken: this.cancelTokenSource.token,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        let towait = maxWait - (new Date() - time);
        // console.log("towait", towait);
        if (towait > 0) {
          await new Promise(accept => {
            window.setTimeout(() => {
              accept();
            }, towait);
          });
        }
        // console.log("time-new Date()", new Date() - time);

        if (response.data.data.ext == ".dcm") this.$router.push("/prosthesis/" + response.data.data.patientId + "/1").catch(err => {});
        else this.$router.push("/ratio/" + response.data.data.patientId).catch(err => {});
      } catch (error) {
        alert("Le format de l'image n'est pas pris en charge.");
        this.spinner = false;
      }
    },
    async finish() {
      this.$router.push("/patients").catch(err => {});
    }
  }
};
</script>

<style scoped lang="scss">
.container-icon {
  background-color: #c6091f;
  border-radius: 50%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.bg-blue {
  height: calc(100vh - 130px);
}

.btn-icon {
  background-color: #c6091f;
  color: white;

  &.disabled {
    background-color: #a7a7a7;
  }
}
</style>
